import React from 'react'
import '../calendar.css'
import { ClockIcon } from '@heroicons/react/20/solid'
import {parse} from 'date-fns'
import InternalCalendarMenu from '../InternalCalendarMenu/InternalCalendarMenu'
import SmallMonthViewCalendar from './SmallMonthViewCalendar/SmallMonthViewCalendar'
import LargeMonthViewCalendar from './LargeMonthViewCalendar/LargeMonthViewCalendar'
import { getCalendarEventDisplayName } from '../calendarDisplayUtils'

const MonthViewCalendar = (props) => {
  let firstDayOfCurrentMonth = parse(props.currentMonth, 'MMMM yyyy', new Date())

  return (
    <div className='calendar__month-view'>
        <div className="calendar__calendar-view-frame">
        <InternalCalendarMenu view={'Month view'} setView={props.setView} selectedDay={props.selectedDay} setSelectedDay={props.setSelectedDay} calendarDaysWithEvents={props.calendarDaysWithEvents} firstDayOfCurrentMonth={firstDayOfCurrentMonth} setCurrentMonth={props.setCurrentMonth} currentMonth={props.currentMonth} />
          <div className='calendar__month-grid-wrap'>
            <div className="calendar__month-grid-surface">
              <div className="calendar__month-weekdays">
                <div>Sun</div>
                <div>Mon</div>
                <div>Tue</div>
                <div>Wed</div>
                <div>Thu</div>
                <div>Fri</div>
                <div>Sat</div>
              </div>
              <div className="calendar__month-grid-body">
                <LargeMonthViewCalendar dayObject={props.dayObject} firstDayOfCurrentMonth={firstDayOfCurrentMonth} setEditEvent={props.setEditEvent} setEventToEdit={props.setEventToEdit} setSelectedDay={props.setSelectedDay} setView={props.setView} createNewCalendarEvent={props.createNewCalendarEvent} />
                <SmallMonthViewCalendar selectedDay={props.selectedDay} dayObject={props.dayObject} firstDayOfCurrentMonth={firstDayOfCurrentMonth} />
              </div>
          </div>
          {props.selectedDay?.events.length > 0 && (
            <div className="py-10 px-4 sm:px-6 lg:hidden">
              <ol className="divide-y divide-gray-100 overflow-hidden rounded-lg bg-white text-sm shadow ring-1 ring-black ring-opacity-5">
                {props.selectedDay.events.map((event) => (
                  <li key={event.id} className="group flex p-4 pr-6 focus-within:bg-gray-50 hover:bg-gray-50">
                    <div className="flex-auto">
                      <p className="font-semibold text-gray-900">{getCalendarEventDisplayName(event.name)}</p>
                      <time dateTime={event.datetime} className="mt-2 flex items-center text-gray-700">
                        <ClockIcon className="mr-2 h-5 w-5 text-gray-400" aria-hidden="true" />
                        {event.time}
                      </time>
                    </div>
                    <a href={event.href} className="ml-6 flex-none self-center rounded-md border border-gray-300 bg-white py-2 px-3 font-semibold text-gray-700 opacity-0 shadow-sm hover:bg-gray-50 focus:opacity-100 group-hover:opacity-100">
                      Edit<span className="sr-only">, {getCalendarEventDisplayName(event.name)}</span>
                    </a>
                  </li>
                ))}
              </ol>
            </div>
          )}
        </div>
        </div>
    </div>
  )
}

export default MonthViewCalendar;
